import format from 'date-fns/format';
import { Typography, Grid, Box } from '@mui/material';
// import useStyles from './styles';

function PaymentDetails(props) {
  const classes = {
    listItem: {
      padding: '2px'
    },
    total: {
      fontWeight: '700'
    },
    title: {
      marginTop: '2px',
      padding: '10px',
    },

  }
  const { debitType, cardBrand, cardNumber, cardExpireFrom, cardExpireTo, cbu } = props.formValues;
  return (
    <Grid item xs={12} sm={6}>
      <Typography
        fontWeight={400}
        variant="h5"
        gutterBottom
        sx={classes.title}>
        Datos del medio de pago
      </Typography>
      <Grid
        container
        sx={{ paddingLeft: '10px', paddingBottom: '10px' }}
      >
        <Box pl={1}>
          <Grid item xs={12}>
            <Typography
              gutterBottom>
              {`${debitType}: ${debitType === 'Tarjeta de Credito' ? cardBrand : cbu}`}
            </Typography>
          </Grid>
          {(debitType === 'Tarjeta de Credito' || debitType === 'Tarjeta de Debito') &&
            <>
              <Typography
                gutterBottom>
                N° de la tarjeta: {cardNumber}
              </Typography>
              <Typography gutterBottom>
                Desde: {cardExpireFrom ? format(new Date(cardExpireFrom), 'MM/yy') : 'No disponible'}
                Hasta: {cardExpireTo ? format(new Date(cardExpireTo), 'MM/yy') : 'No disponible'}
              </Typography>
            </>
          }
        </Box>
      </Grid>
    </Grid>
  );
}

export default PaymentDetails;